import React from 'react';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  const features = [
    {
      icon: '✅',
      title: 'Experienced Professionals',
    description: 'Your home is in safe hands with our professional and reliable team.'
    },
    {
      icon: '🚀',
      title: 'Fast and Clean Work',
      description: 'We work efficiently and always leave your space tidy.'
    },
    {
      icon: '👍',
      title: 'Trusted by Homeowners Across the San Fernando Valley',
      description: 'Our reputation is built on quality work and happy clients.'
    },
    {
      icon: '💰',
      title: 'Transparent Pricing – No Surprises',
      description: 'Clear, upfront pricing so you know exactly what to expect.'
    }
  ];

  return (
    <section className="why-choose-us-section">
      <h2 className="why-choose-us-title">Why Choose Us</h2>
      <div className="features-grid">
        {features.map((feature, index) => (
          <div className="feature-card" key={index}>
            <div className="feature-icon">{feature.icon}</div>
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;
